import styles from './MenuBurgerIcon.module.css';

export default function MenuBurgerIcon({ isOpen }: { isOpen: boolean }) {
  return (
    <div className={`${styles.burger} ${(isOpen) ? styles.open : ''}`}>
      <span />
      <span />
      <span />
    </div>
  );
}
